import { composeMapper } from '@wix/editor-elements-preview-utils';
import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import type {
  LoginSocialBarDefinition,
  ILoginSocialBarPreviewMapperProps,
} from '../LoginSocialBar.types';
import { props as viewerPropsMapper } from './LoginSocialBar.mapper';

const props = composeMapper<
  ILoginSocialBarPreviewMapperProps,
  LoginSocialBarDefinition,
  ILoginSocialBarPreviewMapperProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState'],
    remove: ['fullNameCompType', 'language', 'compId', 'trackClicksAnalytics'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState } = deps;
    const isMenuOpen = compPreviewState === 'loggedInMenuOpened';
    const shouldShowAsLoggedOut = compPreviewState === 'loggedOut';

    return {
      ...viewerProps,
      isMenuOpen,
      isLoggedIn: !shouldShowAsLoggedOut,
      previewWrapperProps: { compPreviewState },
      trackClicksAnalytics: false,
    };
  },
);

export default createComponentPreviewMapperModel({ props });
